import { render, staticRenderFns } from "./BigNumber.vue?vue&type=template&id=5122c2e5"
import script from "./BigNumber.vue?vue&type=script&lang=js"
export * from "./BigNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports